<mat-card class="grid-wrapper mat-elevation-z3">
    <div class="grid-container">
        <div class="grid-wallpaper">
            <img src="../assets/img/wallpaper.jpg" />
        </div>
        <div class="grid-header border zebra red"></div>
        <div class="grid-content zebra green">
            <div style="height: 150vh; width: 90%; margin: auto" class="solid green"></div>
        </div>
        <div class="grid-toc zebra yellow"></div>
        <div class="grid-footer zebra blue"></div>
    </div>
</mat-card>
